@if (authService.isAuthenticated()) {
  <div class="admin-default-layout">
    <div class="admin-default-layout__header">
      <div class="admin-default-layout__left">
        <button
          app-button
          variant="base"
          [disableFocusStyles]="true"
          [onlyIcon]="true"
          (click)="openUsersPage()"
        >
          <app-svg-icon
            name="arrow-left"
            buttonIcon
          />
        </button>

        @if (!!user()) {
          <h1 class="admin-default-layout__title">{{ user()?.name }} page design</h1>
        }
      </div>
    </div>

    @if (!user()) {
      <div class="admin-default-layout__loader">
        <app-loading-indicator />
      </div>
    } @else {
      <div class="admin-default-layout__container">
        <div class="default-layout">
          <app-sidebar [editedUser]="user()"></app-sidebar>

          <div class="default-container">
            <main class="default-container__content">
              <ng-content>
                <router-outlet />
              </ng-content>
            </main>
          </div>
        </div>
      </div>
    }
  </div>
}
